/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import {
    apiUrl,
    handleApiCall,
    securedApiOptions,
    getEnumParams,
    composeCommonQuery
} from './HttpUtils'

const getAssetsApiUrl = () => {
    return apiUrl(`assets`)
}

const getAssetApiUrl = (assetId) => {
    return apiUrl(`assets/${assetId}`)
}

export const fetchAssets = (shallow, search, sort, sortOrder) => {
    return handleApiCall(getAssetsApiUrl() + composeCommonQuery(search, sort, sortOrder) + (shallow ? '&shallow=' + shallow : ''))
}

export const createAssetInGenericFleet = (asset) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = JSON.stringify(asset)
    return handleApiCall(getAssetsApiUrl() + '/createAsset', opts)
}

export const fetchAssetObservation = (assetId, states, types, symptomIds = []) => {
    return handleApiCall(getAssetApiUrl(assetId) + '/observations?createFault=true' +
                            getEnumParams('states', states) +
                            getEnumParams('symptomTypes', types) +
                            getEnumParams('symptomIds', symptomIds))
}

export const fetchPossibleFailureModes = (assetId, symptomIds = []) => {
    return handleApiCall(getAssetApiUrl(assetId) + '/failureMode?' +
                            getEnumParams('symptomIds', symptomIds))
}

export const submitAssetObservations = (assetId, observations) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(observations)
    return handleApiCall(getAssetApiUrl(assetId) + '/observations', opts)
}

export const fetchAsset = (assetId) => {
    return handleApiCall(getAssetApiUrl(assetId))
}